import React from "react";
import Intro from "./components/Intro";
import About from "./components/About";
import Credits from "./components/Credits";
import NavBar from "./components/NavBar";
import Impact from "./components/Impact";
import "./App.css";
import "./styles/Global.css";


function App() {
  return (
    <div
      style={{
        background: 'linear-gradient(to bottom, #f1c5eb, #e0d4aa)',
        minHeight: '100vh', // Ensures the gradient spans the full viewport height
      }}
      className="App"
    >
      <NavBar />
      <div id="content">
        <Intro />
        <About />
        <Impact />
        {/* <Team /> */}
        <Credits />
      </div>
    </div>
  );
}

export default App;
